import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  PARTNER_SESSION_TIMEOUT_EVENT,
  clearPartnerSessionStarted,
} from "./partnerSession";

export default function PartnerSessionTimeoutModal({
  AppModal,
  clearPortalStorage,
  loginPath,
  portalId,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("Your session has expired. Please log in again.");
  const navigate = useNavigate();

  useEffect(() => {
    const handleSessionTimeout = (event) => {
      const nextMessage = String(
        event?.detail?.message || "Your session has expired. Please log in again.",
      );
      setMessage(nextMessage);
      setIsOpen(true);
    };

    window.addEventListener(PARTNER_SESSION_TIMEOUT_EVENT, handleSessionTimeout);
    return () => {
      window.removeEventListener(PARTNER_SESSION_TIMEOUT_EVENT, handleSessionTimeout);
    };
  }, []);

  const goToLogin = () => {
    clearPortalStorage();
    clearPartnerSessionStarted(portalId);
    setIsOpen(false);
    navigate(loginPath, { replace: true });
  };

  useEffect(() => {
    if (!isOpen) return undefined;
    const timer = window.setTimeout(goToLogin, 2200);
    return () => window.clearTimeout(timer);
  }, [isOpen, navigate]);

  if (!AppModal) return null;

  return (
    <AppModal
      open={isOpen}
      onClose={goToLogin}
      title="Session ended"
      size="md"
      zIndex={99998}
      footer={(
        <button
          type="button"
          onClick={goToLogin}
          className="app-modal-btn-primary rounded-xl px-4 py-2 text-sm font-semibold transition"
        >
          Sign in again
        </button>
      )}
    >
      <p className="text-sm font-medium theme-heading">{message}</p>
    </AppModal>
  );
}
